<template>
    <div class="tasks-list-wrapper step_5">
        <div class="summary_icon_wrapper">
            <em class="icon-awesome"></em>
        </div>
        <h1 class="text-center">{{$t('tests.wizard.summary_step.headline')}}</h1>
        <div class="summary_text_wrapper" v-html="$t('tests.wizard.summary_step.text')"></div>
        <b-row class="row-summary-actions">
            <b-col cols="12" md="6">
                <div class="summary_card" @click="previewTest">
                    <em class="icon-preview"></em>
                    <div class="summary_text">
                        <h3>{{$t('tests.wizard.summary_step.preview_test')}}</h3>
                        <p>{{$t('tests.wizard.summary_step.preview_test_text')}}</p>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="6" v-if="$parent.test.own_testers">
                <div class="summary_card" @click="shareLink; $event.target.classList.toggle('copied')">
                    <em class="icon-copylink"></em>
                    <div class="summary_text">
                        <h3>{{$t('tests.wizard.summary_step.copy_test_link')}} <span class="copied-text">Copied!</span></h3>
                        <p>{{$t('tests.wizard.summary_step.copy_test_link_test')}}</p>
                    </div>
                </div>
            </b-col>
        </b-row>

        <tests-wizard-buttons-block :next="seeResults"
                                    :isButtonDisabled="false" :nextLabel="$t('tests.wizard.summary_step.show_results')"
        ></tests-wizard-buttons-block>
    </div>
</template>

<script>
    import { notifications } from '../../mixins/notifications';
    export default {
        name: 'tests-wizard-summary-step',
        mixins: [notifications],
        methods: {
            previewTest(){
                let route = this.$router.resolve({
                        name : 'test-demo-flow-wrapper',
                        params : {hash : this.$parent.test.hash}
                    }),
                    link = window.location.origin + route.href;
                if(this.$clipboard(link)){
                    this.pushNotification(this.$t('tests.wizard.summary_step.link_copied'), 'success', 2000);
                }
            },
            shareLink() {
                let route = this.$router.resolve({name: 'test-flow-wrapper', params: {hash: this.$parent.test.hash}}),
                    link = window.location.origin + route.href;
                if(this.$clipboard(link)) {
                    this.pushNotification(this.$t('tests.wizard.summary_step.link_copied'), 'success', 2000);
                }
            },
            seeResults() {
                this.$router.push({
                    name: 'test_results',
                    params: {testId: this.$parent.test.id}
                });
            }
        }
    }
</script>

<style scoped>

</style>
